// Mock data for TransactWorld website

export const navigationLinks = [
  { name: 'Home', href: '#home' },
  { name: 'About Us', href: '#about' },
  { 
    name: 'Solutions', 
    href: '#solutions',
    dropdown: [
      {
        name: 'IBAN Solutions',
        href: '#iban-solutions',
        children: [
          { name: 'Terms Of Use', href: '/terms-of-use' },
          { name: 'Complaints Policy', href: '/complaints-policy' }
        ]
      },
    ]
  },
  { name: 'Docs', href: '#docs' },
  { name: 'Contact', href: 'https://forms.zohopublic.eu/transactworld/form/ContactUs/formperma/Mr2dMJ1ULtX082SEFJoGYVCNh4NiLak_7S4X2Dj1bSw' }
];

export const heroData = {
  title: 'Your Global Merchant',
  titleHighlight: 'Service Provider',
  subtitle: 'Enabling online payments worldwide.',
  description: 'Secure, swift, and scalable payment gateway solutions for businesses worldwide.',
  ctaButtons: [
    { text: 'Gateway Sign Up', href: '#signup', variant: 'primary' },
    { text: 'IBAN Sign Up', href: '#iban-signup', variant: 'secondary' }
  ],
  slides: [
    {
      image: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=1920&q=80',
      title: 'Global payment solutions',
      subtitle: 'Process payments in 200+ countries.'
    },
    {
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1920&q=80',
      title: 'Advanced security',
      subtitle: 'PCI DSS certified with bank-grade encryption.'
    },
    {
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1920&q=80',
      title: 'Instant integration',
      subtitle: 'Get started in minutes with our REST API.'
    }
  ]
};

export const aboutData = {
  title: 'ABOUT US',
  description: 'TransactWorld is providing a state of the art Payment Gateway Solution representing an essential infrastructure component for the card not-present industry. Being a single entry hub to global markets the TransactWorld Platform represents a bridge between merchants and financial institutions.',
  vision: 'To create value for our customers and partners globally by continuously innovating and providing best-in-class integrated payment solutions.',
  mission: 'To provide diversified innovative and cost effective payment solutions to our customers and partners worldwide. To provide robust and global platform to enable fast and easy processing for banks, acquirers, payments service providers (PSPs) and independent sales organizations (ISOs).'
};

export const coreValues = [
  {
    icon: 'Sparkles',
    title: 'SIMPLE',
    subtitle: 'Simple and Easy Integration',
    description: 'Our REST API allows you to integrate instantly with our platform. Merchants can simply copy the code from our webpage and start testing. All APIs follow the latest development framework helping speed up the merchant on-boarding.'
  },
  {
    icon: 'Shield',
    title: 'SECURE',
    subtitle: 'Secure Transaction',
    description: 'TransactWorld Platform is implemented and audited according to the latest payment card security standards and is PCI DSS certified. Security policies, technologies and processes are enhanced on a continuous basis to ensure all sensitive data is secure.'
  },
  {
    icon: 'Zap',
    title: 'SWIFT',
    subtitle: 'Swift Merchant Onboarding',
    description: 'Boarding Manager, a TransactWorld platform module, is a solution for merchants on-boarding with the banks. All merchant data can be secured for sending application packages to multiple acquirers. Information needs to be filled in only once.'
  },
  {
    icon: 'TrendingUp',
    title: 'SCALABLE',
    subtitle: 'Scalable Platform',
    description: 'Our Platform is built to support your business wherever you are. We are integrated with vast number of international banks, hence if you want to act as a local merchant or prepare to act globally we have the expertise to cater your requirements.'
  }
];

export const solutions = [
  {
    id: 'payment-gateway',
    title: 'PAYMENT GATEWAY',
    description: 'TransactWorld is hosted in secure and fully redundant 24x7x365 datacenters and built to enable all different international payment methods needed to support your country specific business. Needless to say our System is PCI DSS certified.',
    image: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=800&q=80',
    features: ['24/7/365 Uptime', 'PCI DSS Certified', 'Multi-Currency Support', 'Real-time Processing']
  },
  {
    id: 'wallet',
    title: 'M-TRANSACT THE DIGITAL WALLET',
    description: 'M-Transact is a smartphone application allowing online and in-store payments without the need to present your card. It even works with alternative payment options like voucher systems or bank transfer.',
    image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&q=80',
    features: ['Contactless Payments', 'Multiple Payment Methods', 'White Label Option', 'Secure Storage']
  },
  {
    id: 'risk-tracker',
    title: 'RISK TRACKER - THE RISK ENGINE',
    description: 'Risk Tracker is a platform module detecting, analyzing and managing transactions, behaviors and habits of your customers. Collecting and analyzing as many data points as possible are vital elements to manage and fully control your online transactions.',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80',
    features: ['Real-time Monitoring', 'Fraud Detection', 'Behavior Analysis', 'Compliance Management']
  },
  {
    id: 'boarding',
    title: 'MERCHANT BOARDING - THE BOARDING MANAGER',
    description: 'Boarding Manager is a platform module designed to speed up the merchant boarding process with any bank and alternative payment method. By selecting a bank you will get a tailored online form only asking for the very specific data.',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80',
    features: ['Quick Onboarding', 'Tailored Forms', 'Data Security', 'Digital Signatures']
  },
  {
    id: 'invoizr',
    title: 'INVOIZR - THE INVOICING APP',
    description: 'INVOIZR, a smartphone application for creating online invoices which replaces the need to buy expensive POS machines. INVOIZR enables the merchant to share invoice with their customers using mediums like WhatsApp, SMS, Mail etc.',
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&q=80',
    features: ['Mobile Invoicing', 'Multiple Share Options', 'Online Payments', 'Invoice Management']
  }
];

export const features = [
  {
    icon: 'ShieldCheck',
    title: 'ADVANCED FRAUD PREVENTION',
    description: 'For higher security level, TransactWorld Platform applies multiple fraud rules and external partners fraud engines for every processed transaction.'
  },
  {
    icon: 'Lock',
    title: 'PCI DSS COMPLIANT',
    description: 'TransactWorld Platform is PCI DSS v3.2 compliant and every customer of the Platform becomes automatically PCI DSS compliant.'
  },
  {
    icon: 'CreditCard',
    title: 'MULTIPLE PAYMENT METHODS',
    description: 'TransactWorld Platform provides you acceptance of major payment methods including credit cards and debit cards.'
  },
  {
    icon: 'Globe',
    title: 'MULTIPLE CURRENCIES PROCESSING',
    description: 'TransactWorld Platform enables processing transactions in various currencies allowing you to expand your business across borders.'
  },
  {
    icon: 'Code',
    title: 'EASY INTEGRATION',
    description: 'TransactWorld Platform use of efficient development suites, web and mobile SDKs allow you to integrate with the Platform within minutes.'
  },
  {
    icon: 'BarChart3',
    title: 'REAL TIME ANALYTICS',
    description: 'TransactWorld Platform keeps you updated with your real time performance and provides you with deep insights highlighting areas for improvement.'
  }
];

export const paymentPartners = [
  { name: 'Visa', logo: 'VISA' },
  { name: 'Mastercard', logo: 'MC' },
  { name: 'PCI DSS', logo: 'PCI' },
  { name: 'UnionPay', logo: 'UP' },
  { name: 'American Express', logo: 'AMEX' },
  { name: 'Digicert', logo: 'DC' }
];

export const stats = [
  { label: 'Countries Covered', value: '200+' },
  { label: 'Transactions', value: '50Bn+' },
  { label: 'Uptime Guarantee', value: '99.9%' },
  { label: 'Acquiring Networks', value: '1000+' }
];

export const footerData = {
  company: 'TransactWorld Limited',
  address: '3 Thivon Street, Anna Court 8-9, Office 202, CY-1056 Nicosia, Cyprus',
  email: 'support@transactworld.com',
  phone: '+44 20 3129 7109',
  copyright: '© TransactWorld 2026',
  links: [
    { name: 'Cookie Policy', href: '#cookie-policy' },
    { name: 'Privacy Policy', href: '#privacy-policy' },
    { name: 'General Terms and Conditions', href: '#terms' }
  ]
};